import { useState } from "react";
import { api, toast } from "../../App";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import DatePicker from "@/components/DatePicker";
import { FileSpreadsheet } from "lucide-react";

export const ExportCallsButton = ({ start, end }) => {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState({ start, end });
  const [busy, setBusy] = useState(false);
  const download = async () => {
    if (!range.start || !range.end) return toast.error("Pick both dates");
    setBusy(true);
    try {
      const res = await api.get(`/call-logs/export?start_date=${range.start}&end_date=${range.end}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `call_logs_${range.start}_to_${range.end}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      setOpen(false);
    } catch (e) {
      toast.error(e.response?.status === 400 ? "End date must be on or after start date" : "Failed to export call logs");
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Button variant="outline" className="rounded-md3-full" onClick={() => { setRange({ start, end }); setOpen(true); }} data-testid="export-calls-btn">
        <FileSpreadsheet className="mr-2 h-4 w-4" /> Export Calls
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md bg-white" data-testid="export-calls-dialog" onOpenAutoFocus={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle>Export Call Logs</DialogTitle>
            <DialogDescription>Download every call logged in this date range as Excel.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>From</Label>
              <DatePicker value={range.start} onChange={(e) => setRange((r) => ({ ...r, start: e.target.value }))} data-testid="export-calls-start" />
            </div>
            <div className="space-y-2">
              <Label>To</Label>
              <DatePicker value={range.end} onChange={(e) => setRange((r) => ({ ...r, end: e.target.value }))} data-testid="export-calls-end" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={download} disabled={busy} className="bg-md3-primary text-md3-on-primary rounded-md3-full" data-testid="export-calls-download-btn">Download Excel</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
